import React, { useState, useEffect, useRef } from 'react'
import {
  ChevronDown,
  CloudCheck,
  DiamondPlus,
  History,
  FilePenLine,
} from 'lucide-react';
import { useDispatch } from 'react-redux';
import { setToastMessage } from "../../reducers/common.reducer";

//Data
import {
  getAgentDetailsService,
  getWinLossService,
  createWinlossService,
} from '../../services/winloss.service';
import { calculateAgentWinLoss } from '../../utils/helper';
import useGameTypeData from '../../hooks/useGameTypeData';
import InformationModal from "./components/InformationModal";
import EditModal from "./components/EditModal";
import axiosInstance from '../../config/axiosInstance';
import { v4 as uuidv4 } from "uuid";
const WinLossEntry = () => {
  const [gameType, setGameType] = useGameTypeData(); // 🔰 business type (data)

  const [isLoading, setIsLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [expand, setExpand] = useState(false);
  const [open, setOpen] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isEditModal, setIsEditModal] = useState(false)
  const [gameOption, setGameOption] = useState({ gameTypeId: '', gameType: 'BusinessType' });
  const [calculationDate, setCalculationDate] = useState(new Date().toISOString().split('T')[0]);
  const [agentData, setAgentData] = useState([])
  const [filteredData, setFilterData] = useState([])
  const [totalAmount, setTotalAmount] = useState(0);
  const [editData, setEditData] = useState(null);

  const isSubmitting = useRef(false);
  const abortControllerRef = useRef(null);
  let inputRef = useRef(null);
  const dispatch = useDispatch();
  const handleWheel = (event) => event.target.blur();

  const selectGameType = (e) => {
    e.stopPropagation();
    setExpand(!expand);
  }

  const handleCalculateOnPaste = (currentAgent, event) => {
    event.preventDefault(); // default paste behavior
    const inputValue = event.clipboardData.getData("text");
    const { winLoss, commingValue } = calculateAgentWinLoss(currentAgent, inputValue);

    setAgentData(prev => prev.map(agent => {
      if (agent.agentName === currentAgent.agentName) {
        return {
          ...agent,
          winLoss: winLoss,
          siteData: commingValue
        };
      }
      return agent; // Return the original agent if no update is needed
    }))

  }

  const handleCalculateOnInputChange = (currentAgent, event) => {
    const inputValue = event.target.value;
    const { winLoss } = calculateAgentWinLoss(currentAgent, inputValue);
    
    setAgentData(prev => prev.map(agent => {
      if (agent.agentName === currentAgent.agentName) {
        return {
          ...agent,
          winLoss: winLoss,
          siteData: inputValue
        };
      }
      return agent; // Return the original agent if no update is needed
    }))
  };

  const getAgentData = async (gameTypeId, calculationDate, signal) => {
    const data = await getWinLossService(gameTypeId, calculationDate, signal);
    const existingAgentNames = new Set(data?.data?.map(item => item.agentName));

    setAgentData([]);
    try {
      setIsLoading(true)
      let result = await getAgentDetailsService(gameTypeId, calculationDate, signal);
      if (result?.data) {
        const filteredData = result?.data?.filter(
          item => !existingAgentNames.has(item.agentName)
        );
        if (filteredData.length === 0) {
          dispatch(
            setToastMessage({
              message: "Already Exists! All agent names are already in the database.",
              type: "error",
            })
          );
          return;
        }
        let sortedData = filteredData
          .sort((a, b) => a.agentName.localeCompare(b.agentName))
          .map(item => ({ ...item, isReadyOnly: false }));

        setAgentData(sortedData);
      }
    } catch (error) {
      if (error.name === 'AbortError' || error.message === 'canceled') return;
      const errorMessage =
        error?.response?.data?.error?.includes('streaming buffer')
          ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
          : error?.response?.data?.message || error?.message;
      dispatch(
        setToastMessage({
          message: errorMessage,
          type: "error",
        })
      );
    } finally {
      setIsLoading(false)
    }
  }

  const getWinLossData = async (gameTypeId, calculationDate, signal) => {
    setAgentData([]);
    try {
      setIsLoading(true)
      let result = await getWinLossService(gameTypeId, calculationDate, signal);
      if (result.data) {
        const sortedData = result.data
          .sort((a, b) => a.agentName.localeCompare(b.agentName))
          .map(item => ({ ...item, isReadyOnly: true }));
        setAgentData(sortedData);
      }
    }
    catch (error) {
      dispatch(
        setToastMessage({
          message: error?.response?.data?.message || error?.message,
          type: "error",
        })
      );
    }
    finally {
      setIsLoading(false)
    }
  }

  const handleGetAgentData = () => {
    if (isLoading) return;

    setIsEdit(false)
    setIsLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;
    if (!gameOption.gameTypeId) {
      dispatch(
        setToastMessage({
          message: "Please Select Business Type",
          type: "warning",
        })
      );
      setIsLoading(false)
      return;
    }
    getAgentData(gameOption.gameTypeId, calculationDate, signal);

    return () => {
      controller.abort();
    }
  }

  const handleGetWinLossData = () => {
    if (isLoading) return;
    if (!gameOption.gameTypeId) {
      dispatch(
        setToastMessage({
          message: "Please Select Business Type",
          type: "warning",
        })
      );
      return;
    }

    setIsEdit(true)
    setIsLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;
    getWinLossData(gameOption.gameTypeId, calculationDate, signal);

    return () => {
      controller.abort();
    }
  }

    const handleSaveData = async () => {
    try {
       if (isSubmitting.current) return;
       isSubmitting.current = true;
       setCreateLoading(true);

       const filter = agentData
        .filter(el => el.siteData && parseFloat(el.siteData) !== 0)
        .map(el => ({ 
            agentId: el.agentId,
            gameTypeId: el.gameTypeId,
            userId: el.userId,
            siteData: el.siteData ? parseFloat(el.siteData) : 0 ,
            winLoss: el.winLoss ? Math.round(el.winLoss) : 0 ,
            price: el.exchangeUnitRate,
            equation: el.equation,
            showPositive: el.showPositive,
         }));
      const requestId = uuidv4(); 
      const result = await createWinlossService({requestId, calculationDate, agentData: filter });

      const totalAmount = filter.reduce((sum, item) => sum + item.winLoss, 0);
      setTotalAmount(totalAmount)

      if (result?.data) {
        dispatch(setToastMessage({ message: "Success", type: "success" }));
        setAgentData([]);
        setFilterData([]);

        setOpen(true);
      }
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') return;
      const errorMessage =
      error?.response?.data?.error?.includes('streaming buffer')
      ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
      : error?.response?.data?.message || error?.message;
      
      dispatch(setToastMessage({ message: errorMessage, type: "error" }));
    } finally {
      setCreateLoading(false);
      isSubmitting.current = false;
    }
  };

  const handleEditData = (data) => {
    if (isLoading) return;

    setEditData(data);
    setIsEditModal(true);
  }

  const onClose = () => {
    setIsEditModal(false);
    setEditData({});
    handleGetWinLossData();
  }

  // const createAction = async (signal) => {
  //   try {
  //     const filter = agentData
  //       .filter(el => el.siteData && parseFloat(el.siteData) !== 0)
  //       .map(el => ({ 
  //           agentId: el.agentId,
  //           gameTypeId: el.gameTypeId,
  //           userId: el.userId,
  //           siteData: el.siteData ? parseFloat(el.siteData) : 0 ,
  //           winLoss: el.winLoss ? Math.round(el.winLoss) : 0 ,
  //           price: el.exchangeUnitRate,
  //           equation: el.equation,
  //           showPositive: el.showPositive,
  //        }));

  //     const result = await createWinlossService({ calculationDate, agentData: filter }, signal);

  //     const totalAmount = filter.reduce((sum, item) => sum + item.winLoss, 0);
  //     setTotalAmount(totalAmount)

  //     return result;

  //   } catch (error) {
  //     throw error;
  //   }
  // };

  return (
    <div className='flex justify-center items-center w-full h-[90vh] bg-slate-200 overflow-hidden text-sm font-mono font-bold'
      onClick={() => setExpand(false)} >
      <div className='h-[87vh] max-w-7xl w-full mx-auto'>
        <div className='relative flex flex-col sm:flex-row justify-center sm:justify-between items-start sm:items-center w-full h-24 sm:h-16 px-4 bg-white text-gray-700 rounded-md mb-2'>
          <div className='flex gap-2 z-20 mb-2 sm:mb-0'>
            <div className={`bg-[#eef2f6] px-4 py-1.5 w-[200px] flex items-center justify-between rounded-md cursor-pointer`}
              onClick={(e) => selectGameType(e)}>
              <div>{gameOption.gameType}</div>
              <ChevronDown className='text-gray-500' />
            </div>
            {
              expand ?
                <div className="bg-[#eef2f6] w-[200px] absolute top-[60px] cursor-pointer overflow-auto h-[410px] rounded-md">
                  {
                    gameType && gameType.map((game, index) => (
                      <div key={index}
                        className={`${game.gameTypeId !== gameType.length ? "border-b-2" : "border-b-0"}  py-2 px-4 hover:bg-gray-600 hover:text-rectangle  transition-all duration-100 `}
                        onClick={() => setGameOption(game)}
                      >
                        {game.gameType}
                      </div>
                    ))
                  }
                </div> : ""
            }
            <input
              type="date"
              onChange={(e) => setCalculationDate(e.target.value)}
              value={calculationDate}
              className='ms-2 text-gray-700 outline-none bg-[#eef2f6] py-1.5 px-4 w-48 rounded-md'
            />
          </div>
          <div className='flex gap-2'>
            {(isLoading || createLoading) && (
              <div className='flex justify-center items-center mr-4'>
                <div className='w-4 h-4 border-4 border-t-transparent border-blue-500 rounded-full animate-spin'></div>
              </div>
            )}
            {!isEdit && (
              <button
                onClick={handleSaveData}
                disabled={createLoading}
                className={`flex gap-1 mr-4 items-center px-4 py-1.5 rounded-md ${createLoading ? 'opacity-50 cursor-not-allowed' : 'bg-red text-white'}`}
              >
                <CloudCheck size={14} />
                Save
              </button>
            )}
            <button onClick={handleGetAgentData} disabled={isLoading} className='flex gap-3 items-center text-rectangle bg-green px-4 py-1.5 rounded-md'>
              <DiamondPlus size={14} />
              New
            </button>
            <button onClick={handleGetWinLossData} disabled={isLoading} className='flex gap-3 items-center text-rectangle bg-blue-600 px-4 py-1.5 rounded-md'>
              <History size={14} />
              Edit
            </button>
          </div>
        </div>
        <div className='bg-white text-gray-700 rounded-md p-1'>
          <div className='max-h-[75vh] overflow-y-auto overscroll-contain overflow-hidden'>
            {agentData && agentData.length > 0 ? (
              <table className='w-full'>
                <thead className='sticky top-0 bg-slate-100 rounded-t-md uppercase tracking-wider'>
                  <tr>
                    <th className="px-4 py-3 w-6 sm:w-16 text-center" scope="col">No.</th>
                    <th className="px-4 py-3" scope="col">Agent</th>
                    <th className="px-4 py-3 text-center" scope="col">Site Data</th>
                    <th className="px-4 py-3 text-center hidden sm:block" scope="col">Equation</th>
                    <th className="px-4 py-3 text-center" scope="col">Profit / Loss</th>
                    <th className={`px-4 py-3 text-center ${isEdit ? 'block' : 'hidden'}`} scope="col">...</th>
                  </tr>
                </thead>
                <tbody className=''>
                  {agentData.map((data, key) => (
                    <tr className='h-12 border-b border-dashed' key={key}>
                      <td className='px-4 py-2 text-center'>{key + 1}</td>
                      <td className='px-4 py-2 text-center text-gray-900'>{data.agentName}</td>
                      <td className='px-4 py-2 text-center'>
                        <input
                          type="number"
                          inputMode="decimal"
                          ref={inputRef}
                          onWheel={handleWheel}
                          value={data.siteData ? data.siteData : ''}
                          onChange={(e) => handleCalculateOnInputChange(data, e)}
                          onPaste={(e) => handleCalculateOnPaste(data, e)}
                          className='bg-slate-200 max-w-72 w-full outline-none border-none rounded-md px-2 py-1.5 text-end text-gray-900 focus:ring-1 focus:ring-gray-400 focus:outline-none'
                        />
                      </td>
                      <td className='px-4 py-2 text-center hidden sm:block'>
                        <div className='flex justify-between items-center max-w-64 w-full bg-slate-300/50 rounded-full px-4 py-1.5'>
                          <span className='text-center w-full'>{data.exchangeUnitRate}</span>
                          <span className='text-center w-full'>{data.equation}</span>
                          <span className={`text-center w-full ${!data.showPositive && 'text-amber-700'}`}>{data.showPositive ? '(+)' : '(-)'}</span>
                        </div>
                      </td>
                      <td className='px-4 py-2 text-center text-gray-700'>
                        <div className='px-2 rounded-md bg-slate-200 py-1.5 max-w-64 w-full text-end'>{data.winLoss ? Math.round(data.winLoss) : 0}</div>
                      </td>
                      <td
                        className={`px-4 py-3 ${isEdit ? 'flex' : 'hidden'} items-center justify-center`}
                      >
                        <div className="px-2 rounded-md">
                          <FilePenLine size={16}
                            onClick={() => handleEditData(data)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              !isLoading && (
                <div className='flex justify-center items-center h-[75vh]'>
                  <h1 className='text-lg text-slate-300 underline'>» No Data Found «</h1>
                </div>
              ))}
          </div>
        </div>

        {isEditModal && (
          <EditModal
            onClose={onClose}
            setEditData={setEditData}
            editData={editData}
          />
        )}

        {open && (
          <InformationModal
            open={open}
            onClose={() => setOpen(false)}
            gameOption={gameOption}
            totalAmount={totalAmount}
          />
        )}
      </div>
    </div>
  )
}

export default WinLossEntry
